// Missing IsActive (older API) counts as active
export function isDimensionActive(dimension: { IsActive?: boolean }): boolean {
  return dimension.IsActive !== false;
}
